import { Button, Modal, Radio, Space } from "antd";
import React, { useState } from "react";

const PrintInspection = ({ isModalVisible, handleCancel, handleOk }) => {
  const [printInspection, setPrintInspection] = useState(1);
  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setPrintInspection(e.target.value);
  };

  const handleContinue = () => {
    if (printInspection === 1) {
      handleOk();

      window.open("/inspection/print_inspection?showImages=false", "_blank");
    }
    if (printInspection === 2) {
      handleOk();

      window.open("/inspection/print_inspection?showImages=true", "_blank");
    }
  };

  return (
    <div>
      <Modal
        title="Print Inspection"
        open={isModalVisible}
        onCancel={handleCancel}
        onOk={handleContinue}
        centered
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <Button onClick={handleContinue} type="primary">
                Continue
              </Button>
              <Button onClick={handleCancel}>Cancel</Button>
            </div>
            <div></div>
          </div>
        }
      >
        <br />
        <Radio.Group onChange={onChange} value={printInspection}>
          <Space direction="vertical">
            <Radio value={1}>Print without images</Radio>
            <Radio value={2}>Print with full-size images</Radio>
          </Space>
        </Radio.Group>
      </Modal>
    </div>
  );
};

export default PrintInspection;
